import { AccessoryCategory } from '../Constants';
import { GenericSummaryCardDtoResponse } from './generic-summary-card.dto-response';

export class HardwareCategoryCards {
	cards: GenericSummaryCardDtoResponse[];
	categoryName: string;
	showNote: boolean;
	noteLabel: string;
	hasSelectedCard: boolean;
	isActiveTab: boolean;
	// djb:to allow tabs by internal ID rather than name
	catId: AccessoryCategory;
}
